module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-13.6987c7d7.png";